import './App.css';
import { Route, Routes } from 'react-router-dom';
import MainLayout from "./layouts/MainLayout";
import CheckoutLayout from "./layouts/CheckoutLayout";
import All from './pages/all';
import Privacy from './pages/privacy';
import Use from './pages/use';
import Reimbursement from './pages/reimbursement';
import Checkout from './pages/checkout';

function App() {
  return (
    <Routes>
    <Route element={<MainLayout />}>
      <Route path="/" element={<All />}/>
      <Route path="/privacy-policy" element={<Privacy />}/>
      <Route path="/terms-conditions" element={<Use />}/>
      <Route path="/politic-reimbursement" element={<Reimbursement />}/>
    </Route>
    <Route element={<CheckoutLayout />}>
      <Route path="/checkout" element={<Checkout />}/>
    </Route>
  </Routes>
  );
}

export default App;